import { create } from 'zustand';
import { api } from '@/lib/api';

interface ShopInfo {
    shop_name?: string;
    support_email?: string;
    support_phone?: string;
    address?: string;
    currency?: string;
    logo_url?: string;
}

interface SettingsState {
    shopInfo: ShopInfo;
    loading: boolean;
    initialized: boolean;
    fetchSettings: () => Promise<void>;
}

export const useSettings = create<SettingsState>((set) => ({
    shopInfo: {},
    loading: false,
    initialized: false,
    fetchSettings: async () => {
        set({ loading: true });
        try {
            const data = await api.get<any>('/settings');
            set({ shopInfo: data.shop_info || {}, initialized: true });
        } catch (e) {
            console.error("Failed to fetch settings", e);
        } finally {
            set({ loading: false });
        }
    }
}));
